import * as t from "io-ts";
import nullable from "./nullable";
export const createDriverUndispatchedCargoTypes = ({ dateTime, }) => {
    const driverUndispatchedCargoT = t.strict({
        id: t.string,
        invoiceRef: nullable(t.string),
        client: nullable(t.string),
        from: t.strict({
            addressString: t.string,
            dateTime: dateTime,
        }),
        to: t.strict({
            addressString: t.string,
            dateTime: nullable(dateTime),
        }),
    });
    const driverUndispatchedCargosT = t.array(driverUndispatchedCargoT);
    return {
        driverUndispatchedCargoT,
        driverUndispatchedCargosT,
    };
};
//# sourceMappingURL=driver-undispatched-cargo.js.map